import { createSlice, createSelector } from '@reduxjs/toolkit';
import { logout } from './authSlice';

const initialState = {
  activeOrder: null, // This will hold the entire cart object from the backend
  selectedCompanyRuc: localStorage.getItem('selectedCompanyRuc') || null,
  orderId: localStorage.getItem('orderId') || null,
  shippingAddress: localStorage.getItem('shippingAddress')
    ? JSON.parse(localStorage.getItem('shippingAddress'))
    : {},
  billingAddress: localStorage.getItem('billingAddress')
    ? JSON.parse(localStorage.getItem('billingAddress'))
    : {},
  paymentMethod: 'Transfer',
};

const cartSlice = createSlice({
  name: 'cart',
  initialState,
  reducers: {
    setCartState: (state, action) => {
      state.activeOrder = action.payload;
    },
    saveShippingAddress: (state, action) => {
      state.shippingAddress = action.payload;
      localStorage.setItem('shippingAddress', JSON.stringify(action.payload));
    },
    saveBillingAddress: (state, action) => {
      state.billingAddress = action.payload;
      localStorage.setItem('billingAddress', JSON.stringify(action.payload));
    },
    savePaymentMethod: (state, action) => {
      state.paymentMethod = action.payload;
    },
    setSelectedCompany: (state, action) => {
      state.selectedCompanyRuc = action.payload;
      if (action.payload) {
        localStorage.setItem('selectedCompanyRuc', action.payload);
      } else {
        localStorage.removeItem('selectedCompanyRuc');
      }
    },
    setOrderId: (state, action) => {
      state.orderId = action.payload;
      if (action.payload) {
        localStorage.setItem('orderId', action.payload);
      } else {
        localStorage.removeItem('orderId');
      }
    },
    resetCart: (state) => {
      state.activeOrder = null;
      state.selectedCompanyRuc = null;
      state.orderId = null;
      state.billingAddress = {};
      state.shippingAddress = {};
      localStorage.removeItem('selectedCompanyRuc');
      localStorage.removeItem('orderId');
      localStorage.removeItem('billingAddress');
      localStorage.removeItem('shippingAddress');
    },
  },
  extraReducers: (builder) => {
    builder.addCase(logout, (state) => {
      state.activeOrder = null;
      state.selectedCompanyRuc = null;
      state.orderId = null;
      state.billingAddress = {};
      state.shippingAddress = {};
      localStorage.removeItem('selectedCompanyRuc');
      localStorage.removeItem('orderId');
      localStorage.removeItem('billingAddress');
      localStorage.removeItem('shippingAddress');
      // Note: Payment method is intentionally kept as it's not user-specific data
    });
  },
});

export const {
  setCartState,
  saveShippingAddress,
  saveBillingAddress,
  savePaymentMethod,
  setSelectedCompany,
  setOrderId,
  resetCart,
} = cartSlice.actions;

// SELECTORS
const selectCart = (state) => state.cart;

export const selectActiveOrder = createSelector(
  [selectCart],
  (cart) => cart.activeOrder
);

export const selectCartCompanies = createSelector(
  [selectActiveOrder],
  (activeOrder) => {
      const companies = activeOrder?.companies;
      if (!companies) return [];
      if (Array.isArray(companies)) return companies;
      return Object.values(companies);
  }
);

export const selectCartItems = createSelector(
  [selectCartCompanies],
  (companies) => companies.flatMap((c) => c.orderItems || c.items || [])
);

export const selectSelectedCompanyRuc = createSelector(
  [selectCart],
  (cart) => cart.selectedCompanyRuc
);

export default cartSlice.reducer;
